import React, { useEffect, useRef } from 'react';
import { useCentralChat, litoMessage, litoWhatsAppUrl } from '../services/centralChat';
import './LitoChat.css';

/* LitoChatPage: full-page Lito chat, opened in a new tab from mobile (/?lito=IM123) */
function LitoChatPage({ code }) {
    const hostRef = useRef(null);
    const message = code ? litoMessage(code) : '';
    const status = useCentralChat({ active: true, message, hostRef });
    const fallback = status === 'off' || status === 'error';

    useEffect(() => {
        document.title = 'Consultar a Lito · Municipalidad de Rawson';
    }, []);

    // Without central-chat the page has nothing to show: continue on WhatsApp in this same tab
    useEffect(() => {
        if (fallback) window.location.replace(litoWhatsAppUrl(message));
    }, [fallback, message]);

    return (
        <main className="lito-page">
            {!fallback && <div ref={hostRef} className="lito-page__host" />}
            {status !== 'ready' && (
                <div className="lito-chat__loading lito-page__status" role="status">
                    <span className="lito-spinner" aria-hidden="true" />
                    {fallback ? 'Abriendo WhatsApp…' : 'Conectando con Lito…'}
                </div>
            )}
        </main>
    );
}

export default LitoChatPage;
